import React, { useState } from 'react';

import { ExternalVerification } from '@/types/externalVerification';
import Card from '@/ui/components/Card';
import Heading from '@/ui/components/Heading';

import DiscoveredPolicyVerifications from './DiscoveredPolicyVerifications';
import RunVOBForm from './RunVOBForm';
import SaveVOBForm from './SaveVOBForm';
import { Props } from './types';
import VOBResponse from './VOBResponse';

const NewVOB = ({
  insurancePolicy,
  firstName,
  lastName,
  birthday,
  dismissPolicyVerification
}: Props) => {
  const [externalVerification, setExternalVerification] = useState<ExternalVerification | null>(
    null
  );
  const [responseError, setResponseError] = useState<string | null>(null);

  const shouldDisplaySaveVOBButton =
    externalVerification?.policy_verifications[0]?.id && !responseError;

  return (
    <Card className="pt-4 p-2 w-full">
      <Heading value={3} text="New VOB on an existing policy" />
      <hr />
      <RunVOBForm
        insurancePolicy={insurancePolicy}
        firstName={firstName}
        lastName={lastName}
        birthday={birthday}
        dismissPolicyVerification={dismissPolicyVerification}
        setExternalVerification={setExternalVerification}
        setResponseError={setResponseError}
      />
      <hr />

      <VOBResponse
        responseErrorMessage={responseError}
        externalVerification={externalVerification}
      />

      {shouldDisplaySaveVOBButton && insurancePolicy.id && (
        <SaveVOBForm
          externalPolicyVerificationId={externalVerification.policy_verifications[0].id}
          lastVOBNotes={insurancePolicy?.last_verification?.vob_notes}
          dismissPolicyVerification={dismissPolicyVerification}
          planEndDate={insurancePolicy?.plan_end_date}
          insurancePriorityType={insurancePolicy?.priority_type}
          insurancePolicyId={insurancePolicy.id}
        />
      )}
      {insurancePolicy?.id && (
        <DiscoveredPolicyVerifications
          discoveredPolicyVerifications={externalVerification?.discovered_policy_verifications}
          insurancePolicyPriority={insurancePolicy?.priority_type}
          insuranceId={insurancePolicy.id}
        />
      )}
    </Card>
  );
};

export default React.memo(NewVOB);
